var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUnflag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F89521",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2 16.349V20h.2a.6.6 0 0 1 0 1.2H6.6a.6.6 0 0 1 0-1.2H7v-2.451l1.2-1.2zM7.6 3a.6.6 0 0 1 .6.6V4H12v1h4.773c.296 0 .562.128.745.333l-3.775 3.775L16.327 6.2H12.2v4.45L9.851 13H8.2v1.651l-1.2 1.2V3.6a.6.6 0 0 1 .6-.6zm7.423 6.526 2.498 2.81A1 1 0 0 1 16.773 14H11v-.451l1.2-1.201v.452h4.128l-2.155-2.424.85-.85zM10.8 5.2H8.2v6.6h2.6V5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.076 2.076a.6.6 0 0 1 .918.765l-.07.083-17 17a.6.6 0 0 1-.918-.765l.07-.083 17-17z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnflag);
export default __webpack_public_path__ + "static/media/ic-unflag.e99defeec2d1b0e79a9f7b4355588c17.svg";
export { ForwardRef as ReactComponent };